import { ListItem, SplitButton } from '@optimus-web/core';
import { LocalizedText } from '@mews/framework';
import { AvailabilityBlock, AvailabilityBlockState } from '@mews-commander/data-access';
import { TextKey } from '@mews-commander/enums';
import { useAvailabilityBlockStateActions } from '../utils/useAvailabilityBlockStateActions';

interface ButtonConfig {
    primaryAction: () => void;
    primaryActionLabel: Mews.TextKey;
    secondaryActions: {
        label: Mews.TextKey;
        action: () => void;
    }[];
}

interface ChangeAvailabilityBlockStateButtonProps {
    availabilityBlock: AvailabilityBlock;
}

export const ChangeAvailabilityBlockStateButton: React.FC<ChangeAvailabilityBlockStateButtonProps> = ({
    availabilityBlock,
}) => {
    const { makeInquired, makeOptional, confirm, cancel, dialog } = useAvailabilityBlockStateActions(availabilityBlock);

    const currentState = availabilityBlock.state;
    let config: ButtonConfig | null = null;

    if (currentState === AvailabilityBlockState.Inquired) {
        config = {
            primaryAction: makeOptional,
            primaryActionLabel: TextKey.MakeOptional,
            secondaryActions: [
                { label: TextKey.MakeConfirmed, action: confirm },
                { label: TextKey.MakeCanceled, action: cancel },
            ],
        };
    }

    if (currentState === AvailabilityBlockState.Optional) {
        config = {
            primaryAction: confirm,
            primaryActionLabel: TextKey.MakeConfirmed,
            secondaryActions: [
                { label: TextKey.MakeInquired, action: makeInquired },
                { label: TextKey.MakeCanceled, action: cancel },
            ],
        };
    }

    if (!config) {
        return null;
    }

    const { primaryAction, primaryActionLabel, secondaryActions } = config;

    return (
        <>
            {dialog}
            <SplitButton
                onClick={primaryAction}
                label={<LocalizedText textKey={primaryActionLabel} />}
                variant="primary"
            >
                {secondaryActions.map(({ label, action }) => (
                    <ListItem primaryText={<LocalizedText textKey={label} />} onClick={action} key={label} />
                ))}
            </SplitButton>
        </>
    );
};
